import {Button} from 'react-bootstrap'
import {Link} from 'react-router-dom'

const BalanceNotificationLog = () => {
  return (
    <div>
      <div className='card mb-5 mb-xl-10'>
        <div className='card-header border-0 d-flex justify-content-between'>
          <div className='card-title'>
            <h3 className='er mb-0'>Balance Notification Log</h3>
          </div>
          <div className='card-title'>
            <Link to='/dashboard'>
              <Button variant='primary' size='sm'>
                Dashboard
              </Button>
            </Link>
          </div>
        </div>
        <div className='card-body'></div>
      </div>
    </div>
  )
}

export default BalanceNotificationLog
